import React, { useState } from "react";
import { useSelector } from "react-redux";
import Summary from "../../../../components/cases/assets/balanceOfAssets/bankBalance/Summary";

const BankBalances = ({ next, back, tabText }) => {
  const [showDetails, setShowDetails] = useState(false);
  const updates = useSelector((state) => state.auditTrail.updates);
  return (
    <>
      <Summary next={next} back={back} updates={updates} />
      {/* <SuggestionBox
        mainText={tabText}
        tabName="BankBalances"
        next={showDetails}
        click={() => {
          setShowDetails(!showDetails);
        }}
        setVisited={visited}
      /> */}
    </>
  );
};

export default BankBalances;
